import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { CryptoWithdrawalFee } from 'src/app/models/exchange-fees';

@Component({
    selector: 'fees-crypto',
    templateUrl: './fees-crypto.component.html',
    styleUrls: ['./fees-crypto.component.scss', '../fees-page/fees-page.component.scss'],
    standalone: false
})
export class FeesCryptoComponent implements OnChanges {
  readonly CRYPTO_TABLE_ROWS = 7;

  @Input() withdrawalFees: CryptoWithdrawalFee[];

  filteredWithdrawalFees: CryptoWithdrawalFee[][] = [];
  searchValue = '';
  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.withdrawalFees?.previousValue?.length !== changes.withdrawalFees?.currentValue?.length) {
      this.groupWithdrawalFees(changes.withdrawalFees.currentValue);
    }
  }

  groupWithdrawalFees(withdrawalFees: CryptoWithdrawalFee[]) {
    if (withdrawalFees?.length > this.CRYPTO_TABLE_ROWS) {
      const groupIndex = (arrInd: number) => Math.floor(arrInd / this.CRYPTO_TABLE_ROWS);
      const groupedFees: CryptoWithdrawalFee[][] = new Array(groupIndex(withdrawalFees.length)).fill([]);
      withdrawalFees.forEach((item, ind) => {
        const groupInd = groupIndex(ind);
        if (groupedFees?.[groupInd]) {
          groupedFees[groupInd] = [...groupedFees[groupInd], item];
        } else {
          groupedFees[groupInd] = [item];
        }
      });

      // add empty rows to table
      const groupAmount = groupedFees.length - 1;
      const lastSectionLen = groupedFees[groupAmount].length;
      if (lastSectionLen < this.CRYPTO_TABLE_ROWS) {
        const fakeRows = new Array(this.CRYPTO_TABLE_ROWS - lastSectionLen).fill({});
        groupedFees[groupAmount] = [...groupedFees[groupAmount], ...fakeRows];
      }

      this.filteredWithdrawalFees = groupedFees;
    } else {
      this.filteredWithdrawalFees = [withdrawalFees];
    }


  }

  filterSendingCrypto({ filteredItems, searchValue }) {
    this.groupWithdrawalFees(filteredItems);
    this.searchValue = searchValue;
  }

  clearSearchValue() {
    this.searchValue = '';
    this.groupWithdrawalFees(this.withdrawalFees);
  }
}
